import * as React from 'react';
import { patchPath } from 'utils/patch-path';
import { Catalogue } from './catalogue/catalogue';

export type Route = {
  key: React.Key;
  component?: React.ElementType;
  path: string | string[];
  exact?: boolean;
  strict?: boolean;
  routes?: Route[];
};
export type RootRoute = Route & {
  routes: Route[];
};

export const routes: RootRoute[] = [
  {
    key: 'Catalogue',
    component: Catalogue,
    path: patchPath(['/catalogue', '/rooms']),
    exact: true,
    strict: false,
    routes: [],
  },
];
